import { useEffect } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import MediaQuery from 'react-responsive';
import { loadPopovers } from '../Popovers/Popovers';
import { enGB } from 'date-fns/locale';

type SimpleDateInputProps = {
  name: string;
  value: Date | null | undefined;
  error: string;
  placeholder?: string;
  readOnly?: boolean;
  disabled?: boolean;
  displayMinWidth?: number;
  minimumDate?: Date;
  maximumDate?: Date;
  onDateChange: (date: Date | null) => void;
};

const SimpleDateInput = ({
  name,
  value,
  error,
  placeholder,
  readOnly,
  disabled,
  displayMinWidth = 400,
  minimumDate,
  maximumDate,
  onDateChange
}: SimpleDateInputProps): JSX.Element => {
  useEffect(() => {
    loadPopovers();
  }, []);

  registerLocale('enGB', enGB);

  const onChange = (date: Date) => {
    if (date != null && typeof date == 'object') {
      const year = date.getFullYear();
      const month = date.getMonth();
      const day = date.getDate();

      date = new Date(Date.UTC(year, month, day, 0, 0, 0));
    }

    onDateChange(date);
  };

  return (
    <div className={`form-group${error ? ' has-error' : ''}`}>
      <div className={`field date input-group${readOnly ? ' readOnly' : ''}`}>
        <div className='field date input-group small'>
          <MediaQuery maxWidth={displayMinWidth}>
            <DatePicker
              id={name}
              name={name}
              className='form-control'
              placeholderText={placeholder ?? 'DD/MM/YYYY'}
              selected={value}
              onChange={onChange}
              readOnly={readOnly}
              disabled={disabled}
              minDate={minimumDate}
              maxDate={maximumDate}
              locale='enGB'
              dateFormat='dd/MM/yyyy'
              autoComplete='off'
              aria-describedby='button-addon1'
              withPortal
            />
          </MediaQuery>
          <MediaQuery minWidth={displayMinWidth + 1}>
            <DatePicker
              id={name}
              name={name}
              className='form-control'
              placeholderText={placeholder ?? 'DD/MM/YYYY'}
              selected={value}
              onChange={onChange}
              readOnly={readOnly}
              disabled={disabled}
              minDate={minimumDate}
              maxDate={maximumDate}
              locale='enGB'
              dateFormat='dd/MM/yyyy'
              autoComplete='off'
              aria-describedby='button-addon1'
            />
          </MediaQuery>
        </div>
      </div>
      <div className='input'>{error}</div>
    </div>
  );
};

export default SimpleDateInput;
